import styled from '@emotion/styled'

const GateForContentThirdStageTitle = styled.span`
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 10px 0;
    padding: 0;
`

export default GateForContentThirdStageTitle